import { render } from "./ActiveResults.vue?vue&type=template&id=7960926d"
import script from "./ActiveResults.vue?vue&type=script&lang=js"
export * from "./ActiveResults.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/results/ActiveResults.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7960926d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7960926d', __exports__)) {
    console.log('reload')
    api.reload('7960926d', __exports__)
  }
  
  module.hot.accept("./ActiveResults.vue?vue&type=template&id=7960926d", () => {
    console.log('re-render')
    api.rerender('7960926d', render)
  })

}


export default __exports__